
//src/components/Navbar.vue
<template lang="pug">
    div
        b-navbar(toggleable="lg", type="light", variant="light")
            b-container
                b-navbar-brand(:to="{ name : 'home' }") Shi Guorui
                b-navbar-toggle(target="nav-collapse")
                b-collapse(id="nav-collapse", is-nav)
                    b-navbar-nav
                        b-nav-item(:to="{ name: 'artworks' }") Artworks
                        b-nav-item(
                            v-if="FULL_VIEW"
                            :to="{ name: 'projects' }"
                        ) Projects
                        b-nav-item(
                            v-if="FULL_VIEW"
                            :to="{ name: 'news' }"
                        ) News
                        b-nav-item(:to="{ name: 'about' }") About
</template>
<script>
export default {
  data() {
    return {
      FULL_VIEW: false
    };
  }
};
</script>